import { z } from "zod";
import { zCorpCompanyStatus } from "@/types/corp/corpSession.common";
import { zBlockedByKind, zCorpLinkState, zLinkCreatedByKind, zLinkEndedReason, } from "./company.common";
export const zCorpLinkDom = z.object({
    linkId: z.string(),
    companyId: z.string(),
    // `corp_my_employees` (кабинет, TECH-CORP-008/CCR-038): `companyName` подставляет маппер (обязателен в домене),
    // `clientId`/`createdByKind` — `nullable`, если колонок нет.
    companyName: z.string(),
    clientId: z.string().nullable(),
    clientName: z.string().nullable(),
    phoneE164: z.string(),
    employeeLabel: z.string().nullable(),
    validFrom: z.string(),
    validTo: z.string().nullable(),
    state: zCorpLinkState,
    isBlocked: z.boolean(),
    blockedByKind: zBlockedByKind.nullable(),
    blockedAt: z.string().nullable(),
    blockReason: z.string().nullable(),
    endedReason: zLinkEndedReason.nullable(),
    createdAt: z.string(),
    createdByKind: zLinkCreatedByKind.nullable(),
    ordersCount: z.number(),
    lastOrderAt: z.string().nullable(),
    /** Только `v_corp_client_links`. */
    canOrder: z.boolean().nullable(),
    /** Только `v_corp_client_links`. */
    companyStatus: zCorpCompanyStatus.nullable(),
});
